// export const account = "https://overseas.dev/api/account";
export const connector = "https://api.overseas.dev/connection";
export const projectEndpoint = "https://api.overseas.dev/project";
export const serviceEndpoint = "https://api.overseas.dev/service";
export const auth = "https://api.overseas.dev/auth";
export const progress = "https://api.overseas.dev/progress";
export const kubernetesEndpoint = "https://api.overseas.dev/kubernetes";
